"use strict";
/*
 * Copyright 2020 - MATTR Limited
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *     http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bls12381G2KeyPair = exports.Bls12381G1KeyPair = void 0;
var Bls12381G1KeyPair_1 = require("./Bls12381G1KeyPair");
Object.defineProperty(exports, "Bls12381G1KeyPair", { enumerable: true, get: function () { return Bls12381G1KeyPair_1.Bls12381G1KeyPair; } });
var Bls12381G2KeyPair_1 = require("./Bls12381G2KeyPair");
Object.defineProperty(exports, "Bls12381G2KeyPair", { enumerable: true, get: function () { return Bls12381G2KeyPair_1.Bls12381G2KeyPair; } });
//# sourceMappingURL=index.js.map